import React, { useState, useEffect } from 'react';
import { today } from 'helpers.js';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { useSelector } from 'react-redux';
import { utils, writeFileXLSX } from 'xlsx';

import { getVendite } from './functions';

const { SearchBar } = Search;

const Vendite = () => {
  const [date, setDate] = useState(today());

  const { vendite } = useSelector((state) => state.bi);

  useEffect(() => {
    getVendite(date);
  }, [date]);

  const onDownload = () => {
    const sheet = utils.table_to_sheet(document.getElementById('tabella-vendite-cliente'));
    const wb = utils.book_new();
    utils.book_append_sheet(wb, sheet, 'Data');
    writeFileXLSX(wb, 'data.xlsx');
  };

  return (
    <div className="vendite">
      <section id="scroll-section" className="mb-3">
        <h1>Vendite 4 anni</h1>
      </section>
      <section className="mb-3">
        <ul className="nav nav-pills justify-content-between">
          <div className="w-50 nav nav-justified" style={{ maxWidth: 500 }} />

          <div className="w-50 nav justify-content-end" style={{ maxWidth: 400 }}>
            <li className="nav-item me-2">
              <input type="date" className="form-control rounded-pill" value={date} onChange={(e) => setDate(e.target.value)} />
            </li>

            <li className="nav-item">
              <button className="btn btn-primary rounded-pill" onClick={onDownload} type="button">
                Export table
              </button>
            </li>
          </div>
        </ul>
      </section>
      <section>
        <div className="card card-body">
          <ToolkitProvider
            keyField="Cliente"
            data={vendite}
            columns={[
              { dataField: 'Cliente', text: 'Cliente' },
              { dataField: 'AnnoInCorso', text: 'Anno in corso', format: true },
              { dataField: 'AnnoPrec1', text: 'Anno scorso', format: true },
              { dataField: 'AnnoPrec2', text: 'Due anni fa', format: true },
              { dataField: 'AnnoPrec3', text: 'Tre anni fa', format: true },
            ].map((col) => {
              if (col.format) {
                return {
                  ...col,
                  formatter: (cell) => `€ ${cell ? Number(cell).toFixed(2) : 0.0}`,
                };
              }
              return col;
            })}
            search
          >
            {(props) => (
              <div>
                <SearchBar {...props.searchProps} /> <hr />
                <BootstrapTable id="tabella-vendite-cliente" striped bootstrap4 wrapperClasses="table-responsive" {...props.baseProps} />
              </div>
            )}
          </ToolkitProvider>
        </div>
      </section>
    </div>
  );
};

export default Vendite;
